/**
 * The forced-logout alert.
 *
 * `authSlice`'s `sessionLost` reducer (fired by the axios interceptor when a
 * refresh fails, or the server returns `session_revoked` / `refresh_token_invalid`
 * / `token_invalid`) sets `sessionExpired: true` and resets `status` to
 * 'anonymous'. `RequireAuth` reacts to the status change and redirects to
 * `/login` on its own — this modal is the alert layered on top of that, so the
 * user is told *why* they landed back on the login screen instead of just
 * finding themselves there. Rendered once, at the app root, inside the router
 * (it navigates), not per-route.
 */
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from '../../components/common/index.jsx';
import { dismissSessionExpired, selectSessionExpired } from './authSlice.js';

export default function SessionExpiredModal() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const open = useSelector(selectSessionExpired);

  const goToLogin = () => {
    dispatch(dismissSessionExpired());
    navigate('/login', { replace: true });
  };

  return (
    <Modal
      open={open}
      onClose={goToLogin}
      title="Session expired"
      footer={(
        <button type="button" className="btn btn-add btn-sm-x" onClick={goToLogin}>
          Sign in again
        </button>
      )}
    >
      <p className="t-sm ink-2 mb-0">
        Your session has ended, either from inactivity or from signing in elsewhere.
        Sign in again to keep going — nothing you were working on has been lost.
      </p>
    </Modal>
  );
}
